// extracted by mini-css-extract-plugin
export default {"select":"SuperSelect_select__WKRCu","option":"SuperSelect_option__-H3iy"};